import { configureStore } from "@reduxjs/toolkit";
import BookmarkHeaderSlice from "./Reducers/BookmarkHeaderSlice";
import LayoutSlice from "./Reducers/LayoutSlice";
import ThemeCustomizerSlice from "./Reducers/ThemeCustomizerSlice";
import CartSlice from "./Reducers/CartSlice";
import ProductSlice from "./Reducers/ProductSlice";

const Store = configureStore({
  reducer: {
    layout: LayoutSlice,
    cartData: CartSlice,
    product: ProductSlice,
    bookmarkHeader: BookmarkHeaderSlice,
    themeCustomizer: ThemeCustomizerSlice,
  },
});

export default Store;

export type RootState = ReturnType<typeof Store.getState>;
export type AppDispatch = typeof Store.dispatch;
